module.exports = __webpack_public_path__ + "img/abo6.2d4ee438.jpg";